import type { AppConfig } from '@/types';

/**
 * 应用全局配置
 * 访问环境变量
 */

// 获取环境变量并提供默认值
const getEnvVar = (key: string, defaultValue: string): string => {
  // 在Vue 3中，环境变量通过import.meta.env访问
  const env = import.meta.env || {};
  const value = env[key];
  return value !== undefined ? value : defaultValue;
};

// 当前环境
const env = getEnvVar('MODE', 'development');

// 是否启用日志
const enableLogging = getEnvVar('VITE_ENABLE_LOGGING', 'true') === 'true';

// 创建配置对象
const config: AppConfig = {
  // 环境信息
  env: env,
  
  // API 基础URL
  apiBaseUrl: getEnvVar('VITE_API_URL', 'http://127.0.0.1:8000/v1/admin/api'),
  
  // 是否启用日志
  enableLogging: enableLogging,
  
  // 请求超时时间（毫秒）
  requestTimeout: parseInt(getEnvVar('VITE_TIMEOUT', '10000')),
  
  // 日期时间格式
  defaultDateFormat: 'yyyy-MM-dd HH:mm:ss',
  
  // 默认时区
  defaultTimezone: 'UTC+8',
  
  // 开发环境标志
  isDevelopment: env === 'development',
  
  // 生产环境标志
  isProduction: env === 'production',
};

// 预设API基础URL (如果环境变量不可用)
if (!config.apiBaseUrl || config.apiBaseUrl === 'undefined') {
  if (config.isProduction) {
    config.apiBaseUrl = 'https://api.game77z.cc/v1/admin/api';
  } else if (env === 'test') {
    config.apiBaseUrl = 'https://testsw_v7wq3u68hnpssh0kg.game77z.cc/v1/admin/api';
  } else {
    config.apiBaseUrl = 'http://127.0.0.1:8000/v1/admin/api';
  }
}

// 调试信息
if (enableLogging) {
  console.log(`[Config] 当前环境: ${env}`);
  console.log(`[Config] API URL: ${config.apiBaseUrl}`);
  console.log(`[Config] 请求超时: ${config.requestTimeout}ms`);
}

// 导出配置
export default config;
